class RPProductQuickBuy extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.status = null;
    this.addToCartButton = null;
    this.availabilityObserver = null;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('[data-rp-quick-buy-button]');
    this.status = this.querySelector('[data-rp-quick-buy-status]');
    this.addToCartButton = this.getProductForm()?.querySelector('[data-btn-addToCart]');
    this.availabilityObserver = new MutationObserver(() => this.syncAvailability());
    if (this.addToCartButton) {
      this.availabilityObserver.observe(this.addToCartButton, {
        attributes: true,
        attributeFilter: ['disabled', 'data-available'],
      });
    }
    this.syncAvailability();
    this.button?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    this.availabilityObserver?.disconnect();
  }

  getProductForm() {
    return this.closest('form[data-type="add-to-cart-form"]');
  }

  getQuantity(form) {
    const inputs = Array.from(form.querySelectorAll('input[name="quantity"]'));
    const activeInput = inputs.find((input) => !input.disabled && input.offsetParent !== null);
    return activeInput?.value || inputs[0]?.value || '1';
  }

  syncAvailability() {
    if (!this.button || !this.addToCartButton) return;
    this.button.disabled = this.addToCartButton.disabled;
  }

  setLoading(isLoading) {
    if (!this.button) return;
    this.button.disabled = isLoading;
    this.button.toggleAttribute('aria-busy', isLoading);
  }

  async handleClick() {
    const form = this.getProductForm();
    if (!form || !this.button || this.button.disabled) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput?.value) return;

    const formData = new FormData(form);
    formData.set('id', variantInput.value);
    formData.set('quantity', this.getQuantity(form));

    this.setLoading(true);
    if (this.status) this.status.textContent = 'Produsul se adauga in cos.';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || result.message || 'Produsul nu a putut fi adaugat.');
      }

      if (this.status) this.status.textContent = 'Produs adaugat. Se deschide finalizarea comenzii.';
      const checkoutUrl = `${window.Shopify.routes.root}checkout`;
      window.location.assign(checkoutUrl);
    } catch (error) {
      if (this.status) this.status.textContent = error.message;
      this.dispatchEvent(new CustomEvent('rp-product-quick-buy:error', {
        bubbles: true,
        detail: { error },
      }));
      this.setLoading(false);
      this.syncAvailability();
    }
  }
}

if (!customElements.get('rp-product-quick-buy')) {
  customElements.define('rp-product-quick-buy', RPProductQuickBuy);
}
